import getMessageFromError from 'ha/utils/getMessageFromError';

export const UNSET_AVATAR = 'ACTIVATIONMODAL/UNSET_AVATAR';
export const UPLOADING_AVATAR = 'ACTIVATIONMODAL/UPLOADING_AVATAR';
export const UPLOAD_AVATAR_ERROR = 'ACTIVATIONMODAL/UPLOAD_AVATAR_ERROR';
export const UPLOAD_AVATAR_SUCCESS = 'ACTIVATIONMODAL/UPLOAD_AVATAR_SUCCESS';

const uploadingAvatar = () => ({
  type: UPLOADING_AVATAR,
});

const uploadAvatarSuccess = avatarURL => ({
  type: UPLOAD_AVATAR_SUCCESS,
  payload: { avatarURL },
});

const uploadAvatarError = error => ({
  type: UPLOAD_AVATAR_ERROR,
  payload: new Error(error),
  error: true,
});

export function uploadAvatar({ userId, avatar }) {
  return (dispatch, _, { apiV2 }) => {
    dispatch(uploadingAvatar());

    return apiV2
      .uploadAvatar({ userId, avatar })
      .then(response => {
        if (response.status !== 200) throw response;

        dispatch(uploadAvatarSuccess(response.data.avatarURL));
      })
      .catch(error => {
        dispatch(uploadAvatarError(getMessageFromError(error)));
        throw error;
      });
  };
}

export function getFacebookAvatar() {
  return (dispatch, _, { facebook }) => {
    dispatch(uploadingAvatar());

    return facebook
      .getUserAvatar()
      .then(({ url }) => dispatch(uploadAvatarSuccess(url)))
      .catch(error => {
        dispatch(uploadAvatarError(error));
        throw error;
      });
  };
}

export function uploadAvatarByUrl(url) {
  return (dispatch, _, { apiV2 }) => {
    dispatch(uploadingAvatar());

    return apiV2
      .uploadAvatarByUrl(url)
      .then(response => {
        if (!response.ok) throw response;
        dispatch(uploadAvatarSuccess(url));
      })
      .catch(error => {
        dispatch(uploadAvatarError(error.type));
        throw error;
      });
  };
}

export function unsetAvatar() {
  return dispatch => {
    dispatch({ type: UNSET_AVATAR });
  };
}
